module.exports = __webpack_public_path__ + "img/logo.f5948fa7.svg";